export default __webpack_public_path__ + "79a4cc0acbf64567616ee923f4e47748.wav";